<template>
  <div
    v-if="showBanner"
    class="ibx-banner"
  >
    <img
      :src="`${publicPath}img/indego-ibx-banner.svg`"
      alt="Are you insured with Independence?"
      width="265"
      height="62"
    >
    <div>
      <h4>IBX members save 20% on monthly or annual passes!</h4>
      <p>
        <a
          target="_blank"
          href="https://ibx.com"
        >Log in to ibx.com</a>, click on Health & Well-being, then
        Discounts & Reimbursements to access your discount code.
      </p>
      <p>Discount does not apply to renewals. Limit one use per person.</p>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      publicPath: process.env.BASE_URL,
    };
  },
  computed: {
    showBanner() {
      return this.$store.state.systemId === 'indego';
    },
  },
};
</script>
